<template>
  <v-card
    class="coach-profile"
    elevation="3"
  >
    <v-card-title class="d-flex justify-space-between align-start mb-0 pb-3">
      <div>
        <h2>Your profile</h2>
      </div>
    </v-card-title>
    <v-card-text v-if="coach.id">
      <v-row>
        <v-col>
          <div class="header-coach">
            <v-avatar
              class="avatar-wrapper"
              color="primary"
              size="80"
              @click="handlePhotoUpload"
            >
              <img
                v-if="coach.avatar"
                :src="coach.avatar"
              >
            </v-avatar>
            <div class="coach-name">
              <h1>{{ coach.name }}</h1>
              <span><a :href="`mailto:${coach.email}`">{{ coach.email }}</a></span>

              <div class="mt-2">
                <telegram-button
                  small
                  depressed
                  :show="!!coach.id"
                  :url="coach.telegram_bot_url"
                  @reload="init"
                />
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col cols="12">
          <h3>Main info</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Status</td>
              <td><coach-status :value="coach.status" /></td>
            </tr>
            <tr>
              <td>Rating</td>
              <td><v-icon>mdi-star</v-icon> {{ coach.rating }}</td>
            </tr>
            <tr>
              <td>Сountry</td>
              <td>{{ coach.country_name }}</td>
            </tr>
            <tr>
              <td>Languages</td>
              <td>
                <div class="d-flex align-items-center">
                  <v-autocomplete
                    v-model="coach.languages"
                    auto-select-first
                    multiple
                    chips
                    deletable-chips
                    item-value="id"
                    item-text="name"
                    :items="selects.languages"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>Create date</td>
              <td>{{ coach.creation_ts }}</td>
            </tr>
            <tr>
              <td>Details</td>
              <td>{{ coach.details || '-' }}</td>
            </tr>
          </table>
        </v-col>
        <v-col
          v-if="isApproved"
          cols="12"
        >
          <h3>Warzone</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Login</td>
              <td>{{ coach.warzone_login || '-' }}</td>
            </tr>
            <tr>
              <td>Platform</td>
              <td>{{ coach.warzone_platform_name || '-' }}</td>
            </tr>
            <tr>
              <td>wins</td>
              <td>{{ coach.warzone_wins || '-' }}</td>
            </tr>
            <tr>
              <td>Kill</td>
              <td>{{ coach.warzone_kills || '-' }}</td>
            </tr>
            <tr>
              <td>KD</td>
              <td>{{ coach.warzone_kd || '-' }}</td>
            </tr>
          </table>
        </v-col>
        <v-col cols="12">
          <h3>Messengers</h3>
          <table class="info-user-tbl">
            <tr>
              <td>Telegram</td>
              <td>{{ coach.telegram || '-' }}</td>
            </tr>
            <tr>
              <td>Discord</td>
              <td>{{ coach.discord || '-' }}</td>
            </tr>
            <tr>
              <td>Youtube</td>
              <td>{{ coach.youtube || '-' }}</td>
            </tr>
            <tr>
              <td>Facebook</td>
              <td>{{ coach.facebook || '-' }}</td>
            </tr>
            <tr>
              <td>Instagram</td>
              <td>{{ coach.instagram || '-' }}</td>
            </tr>
            <tr>
              <td>Twitch</td>
              <td>{{ coach.twitch || '-' }}</td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <h3>Type & Commissions</h3>
        </v-col>
        <v-col cols="12">
          <table class="info-user-tbl">
            <tr>
              <td>Current level</td>
              <td>{{ level.name }} ({{ level.fee }}%/{{ level.cost }}$)</td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <div
        v-for="(item) in coach.categories"
        :key="item.id"
      >
        <v-row
          v-if="item.category < coach.level"
          style="max-width: 800px"
        >
          <v-col cols="12">
            <v-switch
              v-if="item.category < coach.level"
              v-model="item.active"
              class="level-switch"
              :label="`${item.name} (${item.fee}%/${item.cost}$)`"
              hide-details
            />
          </v-col>
        </v-row>
      </div>
      <v-row class="mt-5">
        <v-col cols="12">
          <h3>Payout Details</h3>
        </v-col>
        <v-col cols="12">
          <table class="info-user-tbl">
            <tr>
              <td>Tip's commission</td>
              <td>{{ `${coach.tips_comission}%` || '-' }}</td>
            </tr>
            <tr>
              <td>Payout info</td>
              <td>{{ coach.payment_info || '-' }}</td>
            </tr>
          </table>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col>
          <v-btn
            class="mt-3"
            dark
            color="success"
            :loading="loading.save"
            @click="save"
          >
            Save
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12">
          <h3>Change password</h3>
          <div class="passowrd-form">
            <v-text-field
              v-model="changePassword.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              label="Current password"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            />
            <v-text-field
              v-model="changePassword.new_password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              label="New password"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
            />
            <v-btn
              color="green"
              dark
              :loading="loading.changePassword"
              @click.native="changePasswordSubmit"
            >
              Save
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-dialog
        v-model="showCropDialog"
        max-width="450"
      >
        <v-card>
          <v-card-text>
            <div class="row pt-5">
              <div class="col-12">
                <vue-cropper
                  v-if="tempAvatar"
                  ref="cropper"
                  :src="tempAvatar"
                  alt="Source Image"
                  :aspect-ratio="1"
                  :min-crop-box-width="cropOptions.width"
                  :min-crop-box-height="cropOptions.height"
                  :view-mode="2"
                  :highlight="false"
                />
              </div>
              <div class="col-12">
                <v-btn
                  text
                  @click="cancelCropAvatar"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="success"
                  class="ml-2"
                  :loading="loading.crop"
                  @click="saveCropAvatar"
                >
                  Save
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <input
        ref="imageInput"
        class="image-input"
        type="file"
        accept="image/*"
        @change="uploadPhoto"
      >
    </v-card-text>
  </v-card>
</template>

<script>
import userAPI from '@/api/user';
import CoachStatus from '@/components/app/statuses/CoachStatus.vue';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import TelegramButton from '@/components/app/TelegramButton.vue';

export default {
  components: { CoachStatus, VueCropper, TelegramButton },
  data: () => ({

    loading: {
      init: false,
      changePassword: false,
      crop: false,
      telegram: false,
      save: false,
    },

    editMode: true,

    showCropDialog: false,

    showDeclineDialog: false,

    coach: {},

    declineForm: {
      reason: '',
    },

    tempAvatar: null,

    cropOptions: {
      width: 192,
      height: 192,
    },

    selects: {
      languages: [],
      levels: [
        { id: '1', title: 'Coach', text: 'Our top coaches will teach you all the tricks and help you win. KD from 2 to 3.5.' },
        { id: '2', title: 'PRO Gamer', text: 'Top players, strong performance. Will lead you to victory. KD from 4 to infinity.' },
        { id: '3', title: 'Streamer', text: 'Guest streamers, interesting and exciting matches. You will also be streamed live.' },
      ],
    },
    stats: {
      min: {},
      data: [],
    },
    showPassword: false,
    changePassword: {
      password: '',
      new_password: '',
    },
  }),

  computed: {

    /**
     * @description статус isPending коуча
     */
    isPending() {
      return this.coach.confirmed === '1';
    },

    /**
     * @description статус isApproved коуча
     */
    isApproved() {
      return this.coach.confirmed === '3';
    },

    /**
     * @description список языков
     */
    languagesList() {
      return Array.prototype.map.call(this.coach.languages, (item) => item.name).join(', ');
    },

    /**
     * @description текущий уровень коуча
     */
    level() {
      return this.coach
        ? this.coach.categories.filter((i) => i.category === this.coach.level)[0]
        : null;
    },
  },

  created() {
    this.init();
  },

  methods: {
    /**
     * @description получение данных профиля
     */
    init() {
      this.loading.init = true;
      userAPI.profile()
        .then((response) => {
          if (response.data.success) {
            this.coach = response.data.data.coach;
            this.stats.min = response.data.data.min_warzone_stat;
            this.stats.data = response.data.data.data;
            this.selects.languages = response.data.data.languages;
          }
        })
        .finally(() => {
          this.loading.init = false;
        });
    },

    /**
     * @description сохранение уровней и языка
     */
    save() {
      this.loading.save = true;

      const data = {
        languages: this.coach.languages,
        categories: this.coach.categories.map((item) => ({
          active: item.active,
          id: item.id,
        })),
      };

      userAPI.save(data)
        .then((response) => {
          if (response.data.success) {
            this.init();
            this.$toast.success('Profile changed succesful!');
          }
        })
        .finally(() => {
          this.loading.save = false;
        });
    },

    /**
     * @description метод открытия файлового менеджера для выбора аватарки
     */
    handlePhotoUpload() {
      this.$refs.imageInput.click();
    },

    /**
     * @description получение выбранного файла и открытие кропера
     * @param {Object} event
     */
    uploadPhoto(event) {
      const { files } = event.target;
      const reader = new FileReader();

      const size = files[0].size / 1000;
      if (size > 350) {
        this.$toast.error('Image size should be no more than 350 kb');
        return;
      }

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          const width = img.naturalWidth;
          const height = img.naturalHeight;

          if (width < this.cropOptions.width || height < this.cropOptions.height) {
            this.$toast.error(`Image must be at least ${this.cropOptions.width}x${this.cropOptions.height} pixels`);
          } else {
            this.tempAvatar = reader.result;
            this.showCropDialog = true;
          }
        };
      };

      reader.readAsDataURL(files[0]);
    },

    /**
     * @description Сохранение в base64 кропера
     */
    saveCropAvatar() {
      const base64Image = this.$refs.cropper.getCroppedCanvas({
        width: this.cropOptions.width,
        height: this.cropOptions.height,
      }).toDataURL('image/jpeg', '1');

      this.loading.crop = true;

      userAPI.uploadAvatar({ data: base64Image })
        .then(async (response) => {
          if (response.data.success) {
            this.$refs.imageInput.value = '';
            this.tempAvatar = null;
            this.init();
            this.$toast.success('Your avatar updated successful');
            this.showCropDialog = false;
            this.loading.crop = false;
          }
        });
    },

    /**
     * @description отмена кропера
     */
    cancelCropAvatar() {
      this.loading.crop = false;
      this.tempAvatar = null;
      this.showCropDialog = false;
    },

    /**
     * @description отправка формы смены пароля
     */
    changePasswordSubmit() {
      this.loading.changePassword = true;
      userAPI.changePassword(this.changePassword)
        .then((response) => {
          if (response.data.success) {
            this.changePassword = {
              password: '',
              new_password: '',
            };
            this.$toast.success('Password changed succesful!');
          }
        })
        .finally(() => {
          this.loading.changePassword = false;
        });
    },
  },
};
</script>

<style lang="scss">

.coach-profile {
  .header-coach {
    display: flex;
    align-items: center;
  }

  .avatar-wrapper {
    &:hover {
      cursor: pointer;
    }
  }

  .v-input--selection-controls {
    .v-label {
      line-height: 0 !important;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .image-input {
    display: none;
  }

  h3 {
    color: #000;
    margin-bottom: 5px;
  }

  .coach-name {
    margin-left: 20px;

    h1 {
      color: #000;
      font-size: 28px;
      margin-bottom: 5px;
    }

    span {
      font-size: 18px;
    }
  }

  .info-user-tbl {
    td {
      padding: 5px 0;
      font-size: 16px;

      &:first-child {
        font-weight: bold;
        padding-right: 20px;
        min-width: 120px;
      }
    }
  }

  .mdi-star {
    color: #ffc800;
    position: relative;
    top: -2px;
  }

  .result-table {
    border: 1px #000 solid;
    border-collapse: collapse;
    color: #000;
    width: 100%;
    font-weight: 600;
    max-width: 700px;

    th {
      font-size: 18px;
      text-align: center;
      padding: 10px;
      border: 1px solid black;
      vertical-align: middle;
    }

    td {
      border: 1px solid black;
      text-align: center;
      padding: 10px;
      vertical-align: middle;

      &:first-of-type {
        text-align: left;
      }
    }

    .platform-icon {
      font-size: 38px;
    }

    .username {
      max-width: 50px;
      min-width: 130px;
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
        text-transform: uppercase;
      }
    }

    .icon-check {
      color: var(--color-success-100);
    }

    .icon-close {
      color: var(--color-danger-100);
    }

    tbody {
      .min-row {
        td {
          font-size: 18px;
          border-top: none;
          //padding-top: 0;
          vertical-align: middle;
        }
      }

      tr {
        .value {
          color: var(--color-danger-100);
        }

        &.allow {
          .value {
            color: var(--color-success-100);
          }
        }
      }
    }
  }

  .level-switch {
    margin-top: 0;

    .v-label {
      margin-bottom: 0 !important;
    }
  }

  .passowrd-form {
    width: 100%;
    max-width: 350px;
    margin-top: 20px;
  }
}

</style>
